import AscenderBoldItalic from '@/assets/fonts/families/ascender/ascender-bold-italic.landrover';
import AscenderBold from '@/assets/fonts/families/ascender/ascender-bold.landrover';
import AscenderItalic from '@/assets/fonts/families/ascender/ascender-italic.landrover';
import Ascender from '@/assets/fonts/families/ascender/ascender.landrover';

const ascenderFonts = [
	AscenderBoldItalic,
	AscenderBold,
	AscenderItalic,
	Ascender,
];

export default ascenderFonts;
